import { RootState } from 'store';
import { StationCategory } from 'entities/stations';

import { STATE } from '../types/state';

const selector = (state: RootState): StationCategory[] => {
  const { stationCategories } = state[STATE];
  return stationCategories;
};

export default selector;
